import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const SignupStart: React.FC = () => {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState<'adult' | 'minor' | null>(null);

  const handleNext = () => {
    if (!selectedType) {
      alert('회원 유형을 선택해주세요.');
      return;
    }

    navigate('/signup/terms', {
      state: { user_type: selectedType }
    });
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <div className="flex-1 bg-gray-50 py-16 mt-20">
        <div className="max-w-4xl mx-auto px-4">
          {/* Contents Head */}
          <div className="mb-10">
            <div className="flex items-center justify-between">
              <h3 className="text-3xl font-bold text-gray-900">통합회원가입</h3>
              <div className="flex gap-4 text-sm">
                <Link to="/login" className="text-gray-600 hover:text-[#48c9a6]">로그인</Link>
                <Link to="/signup" className="text-[#48c9a6] font-medium">통합회원가입</Link>
              </div>
            </div>
            <div className="h-1 bg-[#48c9a6] w-20 mt-4"></div>
          </div>

          {/* Selection Box */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-10">
            {/* 회원유형 선택 */}
            <div>
              <h2 className="flex items-center gap-2 mb-8 text-xl font-bold text-gray-900">
                <svg className="w-6 h-6 text-[#48c9a6]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                </svg>
                회원유형 선택
              </h2>

              <div className="flex gap-6">
                {/* 일반회원 (만 14세 이상) */}
                <button
                  type="button"
                  onClick={() => setSelectedType('adult')}
                  className={`flex-1 border-2 py-10 px-6 text-center transition-all duration-200 rounded-lg ${
                    selectedType === 'adult'
                      ? 'border-[#48c9a6] bg-[#48c9a6]/5'
                      : 'border-gray-200 hover:border-[#48c9a6] hover:bg-[#48c9a6]/5'
                  }`}
                >
                  <div className={`w-20 h-20 mx-auto mb-4 rounded-full flex items-center justify-center ${
                    selectedType === 'adult' ? 'bg-[#48c9a6]/20' : 'bg-gray-100'
                  }`}>
                    <svg className={`w-10 h-10 ${selectedType === 'adult' ? 'text-[#48c9a6]' : 'text-gray-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  </div>
                  <strong className="block text-lg font-semibold text-gray-900">일반회원</strong>
                  <p className="mt-2 text-sm text-gray-500">만 14세 이상</p>
                </button>

                {/* 14세 미만 회원 */}
                <button
                  type="button"
                  onClick={() => setSelectedType('minor')}
                  className={`flex-1 border-2 py-10 px-6 text-center transition-all duration-200 rounded-lg ${
                    selectedType === 'minor'
                      ? 'border-[#48c9a6] bg-[#48c9a6]/5'
                      : 'border-gray-200 hover:border-[#48c9a6] hover:bg-[#48c9a6]/5'
                  }`}
                >
                  <div className={`w-20 h-20 mx-auto mb-4 rounded-full flex items-center justify-center ${
                    selectedType === 'minor' ? 'bg-[#48c9a6]/20' : 'bg-gray-100'
                  }`}>
                    <svg className={`w-10 h-10 ${selectedType === 'minor' ? 'text-[#48c9a6]' : 'text-gray-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                    </svg>
                  </div>
                  <strong className="block text-lg font-semibold text-gray-900">어린이 회원</strong>
                  <p className="mt-2 text-sm text-gray-500">만 14세 미만</p>
                </button>
              </div>
            </div>

            {/* 다음 버튼 */}
            <div className="mt-10">
              <button
                type="button"
                onClick={handleNext}
                disabled={!selectedType}
                className="w-full py-4 px-6 bg-[#48c9a6] text-white font-semibold rounded-lg hover:bg-[#3ab89a] disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
              >
                다음 단계
              </button>
            </div>
          </div>

          {/* 안내 문구 */}
          <div className="mt-6 text-center">
            <p className="text-sm text-gray-500">
              이미 계정이 있으신가요? {' '}
              <Link to="/login" className="text-[#48c9a6] hover:text-[#3ab89a] font-medium">
                로그인
              </Link>
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SignupStart;
